<template>
    <div class="page-scan-out">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門倉庫</div>
            <div class="breadcrumb-item">超時快件核銷</div>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11" push="6">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>快遞單號</span>
                                </div>
                                <Input v-model="form.sack_number" ref='macao_scanout_id'  @keyup.enter.native="handleCheckFrom"/>
                            </FormItem>

                            <FormItem>
                                <div class="pg-btn-wrap pg-form-btn">
                                    <div class="pg-btn style1" @click="handleCheckFrom">核銷</div>
                                    <div class="pg-btn" @click="handleCheckList">查詢</div>
                                </div>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>

            <div v-if="table.data.length > 0">
                <Table size="small"
                       border
                       no-data-text="暫無數據"
                       :columns="table.column"
                       :data="table.data">
                </Table>
            </div>

        </div>
    </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
                suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
                form: {
                    sack_number: '',
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '到店時間',
                            key: 'arrive_time',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '快遞單號',
                            key: 'odd_numbers',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '貨架號',
                            key: 'arriveCode',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '門店',
                            key: 'stroeName',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '超時日期',
                            key: 'outDay',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '狀態',
                            key: 'orderStats',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '電話號碼',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        }
                    ],
                    data: []
                }
            };
        },
        mounted(){
        },
        methods: {
            getCheckedList() {
              let tableData = this.form.sack_number;
              let arr = [];
              arr.push(tableData);
              return arr;
            },

            getOrderBySackNo()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.overtimelist,
                    method: 'get',
                    data: {
                        orderNumber: this.form.sack_number,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        if(resData == undefined)
                        {
                            this.totalCount = 0;
                            this.table.data = tempArr;
                        }
                        else
                        {
                            for (let i = 0, len = resData.length; i < len; i++)
                            {
                                tempArr.push({
                                    arriveCode: resData[i].arriveCode,
                                    arrive_time: resData[i].arrive_time,
                                    cainiao_match: resData[i].cainiao_match,
                                    odd_numbers: resData[i].orderNumber,
                                    orderStats: resData[i].orderStats,
                                    outDay: resData[i].outDay + '天',
                                    phone: resData[i].phone,
                                    status: resData[i].status,
                                    stroeName: resData[i].stroeName,
                                });
                            }
                            this.table.data = tempArr.reverse();
                        }
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleCheckFrom()
            {
                let form = this.form;
                if (form.sack_number === '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }

                this.handleSubmit();
                this.$refs.macao_scanout_id.focus();
                // this.form.sack_number= '';
            },

            handleCheckList()
            {
                let form = this.form;
                if (form.sack_number === '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }

                this.getOrderBySackNo();
                this.$refs.macao_scanout_id.focus();
                // this.form.sack_number= '';
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.overtimedestroy,
                    method: 'post',
                    data: {
                        orderNumber: this.getCheckedList()
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);                       
                        let audio = new Audio()
                        audio.src = this.suc_audio
                        audio.play();
                        this.getOrderBySackNo();
                        this.form = {
                            sack_number: ''
                        };
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                        let audio = new Audio()
                        audio.src = this.err_audio
                        audio.play();
                        this.form = {
                            sack_number: ''
                        };
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                    let audio = new Audio()
                    audio.src = this.err_audio
                    audio.play();
                    this.form = {
                        sack_number: ''
                    };
                });
            },

            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定移出嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.delSack,
                            method: 'post',
                            data: {
                                id: tableData[index].id
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;
                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                tableData.splice(index, 1);
                                this.table.data = tableData;
                            } 
                            else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "overtimeCancel";
</style>